import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetNotifications } from 'services/NotificationServices'
import { apiGetPendingPatientsCount } from 'services/PatientsService'

export const getNotificationsList = createAsyncThunk(
    'notifications/getNotificationsList',
    async (data) => {
        return await apiGetNotifications(data)
    }
)

export const getPendingPatientsCount = createAsyncThunk(
    'notifications/getPendingPatientsCount',
    async () => {
        const response = await apiGetPendingPatientsCount()
        return response.data
    }
)

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        notificationsList: [],
        initialListParams: {
            total: 0,
            pageIndex: 1,
            pageSize: 10,
        },
        pendingPatientsCount: 0,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
    },
    extraReducers: {
        [getNotificationsList.pending]: (state) => {
            state.loading = true
        },
        [getNotificationsList.fulfilled]: (state, action) => {
            state.consultationsList = action.payload
            state.tableData.total = action.payload.length
            state.loading = false
        },
        [getPendingPatientsCount.fulfilled]: (state, action) => {
            state.pendingPatientsCount = action.payload?.count || 0
        },
    },
})

export const { onSignInSuccess, onSignOutSuccess, setToken } =
    notificationsSlice.actions

export default notificationsSlice.reducer
